import { schema } from "normalizr";

const EmployeeSaleCommissionSchema = new schema.Entity("employeeSaleCommissions");
const EmployeeSaleCommissionArraySchema = new schema.Array(EmployeeSaleCommissionSchema);

export { 
  EmployeeSaleCommissionSchema,
  EmployeeSaleCommissionArraySchema
};